// @flow

import type {BiePluginType} from '../types';
import {CanvasManager} from '../managers/canvas-manager';

export class BieFlipPlugin implements BiePluginType {
  setup() {}

  getActionButtons() {
    return [
      {
        type: 'immediate-action',
        title: 'Flip horizontally',
        icon: 'fas fa-arrows-alt-h',
        slug: 'flip-x',
        cb: this.flipX,
      },
      {
        type: 'immediate-action',
        title: 'Flip vertically',
        icon: 'fas fa-arrows-alt-v',
        slug: 'flip-y',
        cb: this.flipY,
      },
    ];
  }

  flipX = (cm: CanvasManager) => {
    this.toggleFlip(cm, 'flipX');
  };

  flipY = (cm: CanvasManager) => {
    this.toggleFlip(cm, 'flipY');
  };

  toggleFlip = (cm: CanvasManager, flip: 'flipY' | 'flipX') => {
    const activeObject = cm.selectAll();
    activeObject[flip] = !activeObject[flip];
    cm.canvas.discardActiveObject();
    cm.canvas.renderAll();
    cm.saveState();
  };
}
